import React from "react"
import { Container } from "reactstrap"
import BankAccounts from "./BankAccounts/BankAccounts"
import DebitCards from "./DebitCards/DebitCards"

const PaymentMethod = () => {




  return (
    <section>
      <Container fluid>

        <BankAccounts />

        <DebitCards />
        
      </Container>
    </section>
  )
}

export default PaymentMethod
